import styled from "styled-components";
import Modal from '@material-ui/core/Modal';

export const ModalMessageWrapper = styled(Modal)`
&& {
display: flex;
overflow: hidden;
justify-content: center;
align-items: center;
}
`;

export const ModalMessageBody = styled.div`
max-width: 75%;
min-height: 144px;
padding: 8px;
display: flex;
font-size: 16px;
font-weight: bold;
line-height: 19px;
display: flex;
align-items: center;
text-align: center;
flex-direction: column;
justify-content: space-around;
color: #000000;
background: #FFFFFF;
border-radius: 15px;
`

export const ModalMessageButton = styled.button`
width: 119px;
height: 35px;
border: none;
font-weight: bold;

background: #228B22;
border-radius: 30px;
font-size: 16px;
line-height: 19px;
align-items: center;
text-align: center;

color: #FFFFFF;
`
